import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-data-warehouse-list-share-principals-modal",
  imports: [TranslocoDirective],
  templateUrl: "./data-warehouse-list-share-principals-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataWarehouseListSharePrincipalsModalComponent {
  protected readonly modalRef = inject(ModalRef);
  protected readonly gcPrincipals = inject<Array<string>>(MODAL_DATA);
}
